import { createSlice } from '@reduxjs/toolkit';
import {
  saveResource,
  updateResource,
  deleteResource,
  resourceDetailsPagenation,
  disableResourceSharing,
  shareResource,
  accessResource,
  resourceDetails,
  getResourceList,
  downloadResource,
  resourceupdate,resourceLike,resourceComment
} from 'services/actions/resourceActoin';

interface ResourceState {
  saveResourceLoading: boolean;
  saveResourceError: any;
  saveResourceSuccess: boolean;
  saveResourceInfo: any;
  updateResourceLoading: boolean;
  updateResourceError: any;
  updateResourceSuccess: boolean;
  updateResourceInfo: any;
  deleteResourceLoading: boolean;
  deleteResourceError: any;
  deleteResourceSuccess: boolean;
  deleteResourceInfo: any;
  shareResourceLoading: boolean;
  shareResourceError: any;
  shareResourceSuccess: boolean;
  shareResourceInfo: any;
  disableResourceSharingLoading: boolean;
  disableResourceSharingError: any;
  disableResourceSharingSuccess: boolean;
  disableResourceSharingInfo: any;
  accessResourceLoading: boolean;
  accessResourceError: any;
  accessResourceSuccess: boolean;
  accessResourceInfo: any;
  resourceDetailsLoading: boolean;
  resourceDetailsError: any;
  resourceDetailsSuccess: boolean;
  resourceDetailsInfo: any;
  getResourceListLoading: boolean;
  getResourceListError: any;
  getResourceListSuccess: boolean;
  getResourceListInfo: any;
  resourceDetailsPagenationLoading: boolean;
  resourceDetailsPagenationError: any;
  resourceDetailsPagenationSuccess: boolean;
  resourceDetailsPagenationInfo: any;
  downloadResourceLoading: boolean;
  downloadResourceError: any;
  downloadResourceSuccess: boolean;
  downloadResourceInfo: any;
  resourceReUploadLoading: boolean;
  resourceReUploadError: any;
  resourceReUploadSuccess: boolean;
  resourceReUploadInfo: any;
  resourceLikeLoading: boolean;
  resourceLikeError: any;
  resourceLikeSuccess: boolean;
  resourceLikeInfo: any;
  resourceCommentLoading: boolean;
  resourceCommentError: any;
  resourceCommentSuccess: boolean;
  resourceCommentInfo: any;
}

const initialState: ResourceState = {
  saveResourceLoading: false,
  saveResourceError: null,
  saveResourceSuccess: false,
  saveResourceInfo: null,
  updateResourceLoading: false,
  updateResourceError: null,
  updateResourceSuccess: false,
  updateResourceInfo: null,
  deleteResourceLoading: false,
  deleteResourceError: null,
  deleteResourceSuccess: false,
  deleteResourceInfo: null,
  shareResourceLoading: false,
  shareResourceError: null,
  shareResourceSuccess: false,
  shareResourceInfo: null,
  disableResourceSharingLoading: false,
  disableResourceSharingError: null,
  disableResourceSharingSuccess: false,
  disableResourceSharingInfo: null,
  accessResourceLoading: false,
  accessResourceError: null,
  accessResourceSuccess: false,
  accessResourceInfo: null,
  resourceDetailsLoading: false,
  resourceDetailsError: null,
  resourceDetailsSuccess: false,
  resourceDetailsInfo: null,
  getResourceListLoading: false,
  getResourceListError: null,
  getResourceListSuccess: false,
  getResourceListInfo: null,
  resourceDetailsPagenationLoading: false,
  resourceDetailsPagenationError: null,
  resourceDetailsPagenationSuccess: false,
  resourceDetailsPagenationInfo: null,
  downloadResourceLoading: false,
  downloadResourceError: null,
  downloadResourceSuccess: false,
  downloadResourceInfo: null,
  resourceReUploadLoading: false,
  resourceReUploadError: null,
  resourceReUploadSuccess: false,
  resourceReUploadInfo: null,
  resourceLikeLoading: false,
  resourceLikeError: null,
  resourceLikeSuccess: false,
  resourceLikeInfo: null,
  resourceCommentLoading: false,
  resourceCommentError: null,
  resourceCommentSuccess: false,
  resourceCommentInfo: null,
};

const resourceSlice = createSlice({
  name: 'resource',
  initialState,
  reducers: {
    resetSaveResourceState: (state) => {
      state.saveResourceLoading = false;
      state.saveResourceSuccess = false;
      state.saveResourceError = null;
      state.saveResourceInfo = null;

      state.updateResourceLoading = false;
      state.updateResourceSuccess = false;
      state.updateResourceError = null;
      state.updateResourceInfo = null;

      state.resourceReUploadLoading = false;
      state.resourceReUploadSuccess = false;
      state.resourceReUploadError = null;
      state.resourceReUploadInfo = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(saveResource.pending, (state) => {
        state.saveResourceLoading = true;
        state.saveResourceError = null;
        state.saveResourceSuccess = false;
        state.saveResourceInfo = null;
      })
      .addCase(saveResource.fulfilled, (state, { payload }) => {
        state.saveResourceLoading = false;
        state.saveResourceInfo = payload;
        state.saveResourceSuccess = true;
      })
      .addCase(saveResource.rejected, (state, { payload }) => {
        state.saveResourceLoading = false;
        state.saveResourceError = payload;
        state.saveResourceSuccess = false;
        state.saveResourceInfo = null;
      })
      .addCase(updateResource.pending, (state) => {
        state.updateResourceLoading = true;
        state.updateResourceError = null;
        state.updateResourceSuccess = false;
        state.updateResourceInfo = null;
      })
      .addCase(updateResource.fulfilled, (state, { payload }) => {
        state.updateResourceLoading = false;
        state.updateResourceInfo = payload;
        state.updateResourceSuccess = true;
      })
      .addCase(updateResource.rejected, (state, { payload }) => {
        state.updateResourceLoading = false;
        state.updateResourceError = payload;
        state.updateResourceSuccess = false;
        state.updateResourceInfo = null;
      })
      .addCase(deleteResource.pending, (state) => {
        state.deleteResourceLoading = true;
        state.deleteResourceError = null;
        state.deleteResourceSuccess = false;
        state.deleteResourceInfo = null;
      })
      .addCase(deleteResource.fulfilled, (state, { payload }) => {
        state.deleteResourceLoading = false;
        state.deleteResourceInfo = payload;
        state.deleteResourceSuccess = true;
      })
      .addCase(deleteResource.rejected, (state, { payload }) => {
        state.deleteResourceLoading = false;
        state.deleteResourceError = payload;
        state.deleteResourceSuccess = false;
        state.deleteResourceInfo = null;
      })
      .addCase(shareResource.pending, (state) => {
        state.shareResourceLoading = true;
        state.shareResourceError = null;
        state.shareResourceSuccess = false;
        state.shareResourceInfo = null;
      })
      .addCase(shareResource.fulfilled, (state, { payload }) => {
        state.shareResourceLoading = false;
        state.shareResourceInfo = payload;
        state.shareResourceSuccess = true;
      })
      .addCase(shareResource.rejected, (state, { payload }) => {
        state.shareResourceLoading = false;
        state.shareResourceError = payload;
        state.shareResourceSuccess = false;
        state.shareResourceInfo = null;
      })
      .addCase(disableResourceSharing.pending, (state) => {
        state.disableResourceSharingLoading = true;
        state.disableResourceSharingError = null;
        state.disableResourceSharingSuccess = false;
        state.disableResourceSharingInfo = null;
      })
      .addCase(disableResourceSharing.fulfilled, (state, { payload }) => {
        state.disableResourceSharingLoading = false;
        state.disableResourceSharingInfo = payload;
        state.disableResourceSharingSuccess = true;
      })
      .addCase(disableResourceSharing.rejected, (state, { payload }) => {
        state.disableResourceSharingLoading = false;
        state.disableResourceSharingError = payload;
        state.disableResourceSharingSuccess = false;
        state.disableResourceSharingInfo = null;
      })
      .addCase(accessResource.pending, (state) => {
        state.accessResourceLoading = true;
        state.accessResourceError = null;
        state.accessResourceSuccess = false;
        state.accessResourceInfo = null;
      })
      .addCase(accessResource.fulfilled, (state, { payload }) => {
        state.accessResourceLoading = false;
        state.accessResourceInfo = payload;
        state.accessResourceSuccess = true;
      })
      .addCase(accessResource.rejected, (state, { payload }) => {
        state.accessResourceLoading = false;
        state.accessResourceError = payload;
        state.accessResourceSuccess = false;
        state.accessResourceInfo = null;
      })
      .addCase(resourceDetails.pending, (state) => {
        state.resourceDetailsLoading = true;
        state.resourceDetailsError = null;
        state.resourceDetailsSuccess = false;
        state.resourceDetailsInfo = null;
      })
      .addCase(resourceDetails.fulfilled, (state, { payload }) => {
        state.resourceDetailsLoading = false;
        state.resourceDetailsInfo = payload;
        state.resourceDetailsSuccess = true;
      })
      .addCase(resourceDetails.rejected, (state, { payload }) => {
        state.resourceDetailsLoading = false;
        state.resourceDetailsError = payload;
        state.resourceDetailsSuccess = false;
        state.resourceDetailsInfo = null;
      })
      .addCase(getResourceList.pending, (state) => {
        state.getResourceListLoading = true;
        state.getResourceListError = null;
        state.getResourceListSuccess = false;
        state.getResourceListInfo = null;
      })
      .addCase(getResourceList.fulfilled, (state, { payload }) => {
        state.getResourceListLoading = false;
        state.getResourceListInfo = payload;
        state.getResourceListSuccess = true;
      })
      .addCase(getResourceList.rejected, (state, { payload }) => {
        state.getResourceListLoading = false;
        state.getResourceListError = payload;
        state.getResourceListSuccess = false;
        state.getResourceListInfo = null;
      })
      .addCase(resourceDetailsPagenation.pending, (state) => {
        state.resourceDetailsPagenationLoading = true;
        state.resourceDetailsPagenationError = null;
        state.resourceDetailsPagenationSuccess = false;
        state.resourceDetailsPagenationInfo = null;
      })
      .addCase(resourceDetailsPagenation.fulfilled, (state, { payload }) => {
        state.resourceDetailsPagenationLoading = false;
        state.resourceDetailsPagenationInfo = payload;
        state.resourceDetailsPagenationSuccess = true;
      })
      .addCase(resourceDetailsPagenation.rejected, (state, { payload }) => {
        state.resourceDetailsPagenationLoading = false;
        state.resourceDetailsPagenationError = payload;
        state.resourceDetailsPagenationSuccess = false;
        state.resourceDetailsPagenationInfo = null;
      })
      .addCase(downloadResource.pending, (state) => {
        state.downloadResourceLoading = true;
        state.downloadResourceError = null;
        state.downloadResourceSuccess = false;
        state.downloadResourceInfo = null;
      })
      .addCase(downloadResource.fulfilled, (state, { payload }) => {
        state.downloadResourceLoading = false;
        state.downloadResourceInfo = payload;
        state.downloadResourceSuccess = true;
      })
      .addCase(downloadResource.rejected, (state, { payload }) => {
        state.downloadResourceLoading = false;
        state.downloadResourceError = payload;
        state.downloadResourceSuccess = false;
        state.downloadResourceInfo = null;
      })
      .addCase(resourceupdate.pending, (state) => {
        state.resourceReUploadLoading = true;
        state.resourceReUploadError = null;
        state.resourceReUploadSuccess = false;
        state.resourceReUploadInfo = null;
      })
      .addCase(resourceupdate.fulfilled, (state, { payload }) => {
        state.resourceReUploadLoading = false;
        state.resourceReUploadInfo = payload;
        state.resourceReUploadSuccess = true;
      })
      .addCase(resourceupdate.rejected, (state, { payload }) => {
        state.resourceReUploadLoading = false;
        state.resourceReUploadError = payload;
        state.resourceReUploadSuccess = false;
        state.resourceReUploadInfo = null;
      })
      .addCase(resourceLike.pending, (state) => {
        state.resourceLikeLoading = true;
        state.resourceLikeError = null;
        state.resourceLikeSuccess = false;
        state.resourceLikeInfo = null;
      })
      .addCase(resourceLike.fulfilled, (state, { payload }) => {
        state.resourceLikeLoading = false;
        state.resourceLikeInfo = payload;
        state.resourceLikeSuccess = true;
      })
      .addCase(resourceLike.rejected, (state, { payload }) => {
        state.resourceLikeLoading = false;
        state.resourceLikeError = payload;
        state.resourceLikeSuccess = false;
        state.resourceLikeInfo = null;
      })
      .addCase(resourceComment.pending, (state) => {
        state.resourceCommentLoading = true;
        state.resourceCommentError = null;
        state.resourceCommentSuccess = false;
        state.resourceCommentInfo = null;
      })
      .addCase(resourceComment.fulfilled, (state, { payload }) => {
        state.resourceCommentLoading = false;
        state.resourceCommentInfo = payload;
        state.resourceCommentSuccess = true;
      })
      .addCase(resourceComment.rejected, (state, { payload }) => {
        state.resourceCommentLoading = false;
        state.resourceCommentError = payload;
        state.resourceCommentSuccess = false;
        state.resourceCommentInfo = null;
      });
  },
});

export const { resetSaveResourceState } = resourceSlice.actions;
export default resourceSlice.reducer;